const ACTION_TYPE = "PAYMENTS";
export const GET_ALL_PAYMENTS_FAIL = `${ACTION_TYPE}/GET_ALL_PAYMENTS_FAIL`;
export const GET_ALL_PAYMENTS_SUCCESS = `${ACTION_TYPE}/GET_ALL_PAYMENTS_SUCCESS`;
